<div class="container">
    <field-config-base #base [config]="config" [dataType]="dataType"></field-config-base>
</div>